import { render, staticRenderFns } from "./DialogEmergencias.vue?vue&type=template&id=68aedcd2&scoped=true"
import script from "./DialogEmergencias.vue?vue&type=script&lang=js"
export * from "./DialogEmergencias.vue?vue&type=script&lang=js"
import style0 from "./DialogEmergencias.vue?vue&type=style&index=0&id=68aedcd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68aedcd2",
  null
  
)

export default component.exports